import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import Typewriter from 't-writer.js';
import { SeoService } from '../../services/seo.service';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { IParallaxScrollConfig } from 'ngx-parallax-scroll';

import AOS from "aos";
@Component({
  selector: 'app-imagine-app',
  templateUrl: './imagine-app.component.html',
  styleUrls: ['./imagine-app.component.scss']
})
export class ImagineAppComponent implements OnInit {

  public next:boolean;
  public up:boolean;
  public value:string;
  public sound:boolean;
  public mute:boolean;
  public video1: boolean;
  public video2: boolean;
  public video3: boolean;
  public video4: boolean;
  public video5: boolean;
  public video6: boolean;

  public itsMobile = false;
  public stream ='https://player.vimeo.com/external/926432247.m3u8?s=9f9f29064565558a8b079728992b325fa1392a53&logging=false';

  ngParallaxConf: IParallaxScrollConfig = {
    parallaxSpeed: 1,
    parallaxSmoothness: 1,
    parallaxDirection: 'reverse',
    parallaxTimingFunction: 'ease-in',
    parallaxThrottleTime: 80
  };
  constructor(private el: ElementRef, private title: Title, private seo: SeoService) {
    this.value = "navigator"
  }

  @HostListener('window:scroll', [])

  onWindowScroll() {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const image = this.el.nativeElement.querySelector('.img-cymi');

    const logOne = this.el.nativeElement.querySelectorAll('.logo-cymi-aos');
    const logoCymi = this.el.nativeElement.querySelector('.al');

    const sectionVideo = this.el.nativeElement.querySelectorAll('.video-play');

    for (var val of logOne) {
      if(val.classList.contains('four') || val.classList.contains('five')){
        if(offset >= val.offsetTop - 500){
          val.classList.add('animate');
        }else{
          val.classList.remove('animate');
        }
      }else{
        if(offset >= val.offsetTop - 400){
          val.classList.add('animate');
        }else{
          val.classList.remove('animate');
        }
      }

    }

    if(offset == 0){
      image.style.transform = 'translateY(0)';
      image.style.opacity = '1';
    }

    if(offset >= logoCymi.offsetTop - 300){
      logoCymi.classList.add('animate');
    }else{
      logoCymi.classList.remove('animate');
    }

    for (var val of sectionVideo) {
      if(offset >= val.offsetTop - 300){

        if(val.className == 'first-child video-play'){
          const video = this.el.nativeElement.querySelector('.first-child .right video');
          video.play();
        }else if(val.className == 'fund-middle second video-play'){
          const video = this.el.nativeElement.querySelector('.second .left video');
          video.play();
        }else if(val.className == 'third video-play'){
          const video = this.el.nativeElement.querySelector('.third .right video');
          video.play();
        }else if(val.className == 'fund-middle fourth video-play'){
          const video = this.el.nativeElement.querySelector('.fourth .left video');
          video.play();
        }else if(val.className == 'fifth video-play'){
          const video = this.el.nativeElement.querySelector('.fifth .right video');
          video.play();
        }else if(val.className == 'fund-middle sixth video-play'){
          const video = this.el.nativeElement.querySelector('.sixth .left video');
          video.play();
        }
      }

    }

  }
  loadAssets() {
    let elementsSrc = document.querySelectorAll('[src-tmp]');

    elementsSrc.forEach((theElement: any) => {
      if (theElement.src != undefined) {
        theElement.src = theElement.getAttribute('src-tmp');
        theElement.removeAttribute('src-tmp');
      }
    });

    // $.each(, function (index, theElement) {
    //
    // });
  }
  ngOnInit(): void {

    AOS.init();

    const target = document.querySelector('.target')
    const target2 = document.querySelector('.target2')
    const target3 = document.querySelector('.target3')
    const target4 = document.querySelector('.target4')


    if (this.verifyMobile()) {
      this.itsMobile = true;
    }


    this.loadAssets();

    const theTitle = 'MENA Region';
    this.title.setTitle(theTitle);

    this.seo.generateTags({
      title: theTitle,
      keyword: '',
      description: "",
      image: ''
    });

    const writer = new Typewriter(target, {
      typeSpeed: 10,
      typeColor: 'white'
    })

    const writer2 = new Typewriter(target2, {
      typeSpeed: 10
    })

    const writer3 = new Typewriter(target3, {
      typeSpeed: 10
    })

    const writer4 = new Typewriter(target4, {
      typeSpeed: 10
    })

    writer
      .type('Welcome to')
      .rest(1000)
      .start()

    setTimeout(function(){
      writer2
        .type(' imagine as One')
        .rest(1500)
        .start()
    }, 500)

    setTimeout(function(){
      writer3
        .type(', the gateway to a world of seamless integration. I' + "´" + 'm allex, your navigator, here to guide you through an experience where convenience meets possibility.')
        .rest(500)
        .start()
    }, 1000)

  setTimeout(function(){
    writer4
      .type('Click to embark on our journey.')
      .rest(500)
      .start()
  }, 4000)
}

verifyMobile(): any {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];


  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

  nextStep(){
    this.next = true;
    const video = this.el.nativeElement.querySelector('video.video-sound');
    video.muted = false;
    video.load();
    video.play();
  }

  prevStep(){
    this.next = false;
    const video = this.el.nativeElement.querySelector('video.video-sound');
    video.pause();
    video.load();
    const video2 = this.el.nativeElement.querySelector('video.video-navigator');
    video2.pause();
    video2.load();
    this.mute = false;
    this.up = false;
  }

  search(){
    const video = this.el.nativeElement.querySelector('video.video-navigator');
    video.play();
    this.mute = false;
    const video3 = this.el.nativeElement.querySelector('video.video-sound');
    video3.pause();
    video3.load();
    this.up = !this.up;
    if(this.up){
      this.value = "Emirates";
    }else{
      this.value = "navigator";
      video.pause();
      video.load();
      this.mute = true;
    }

  }

  openVideo(number: any) {

    this["video" + number] = true;
    this.pauseAllVideos();
    this.mute = true;
    const video = this.el.nativeElement.querySelector('video.video-sound');
    const video2 = this.el.nativeElement.querySelector('video.video-navigator');
    video.pause();
    video2.pause();

    setTimeout(() => {
      if (number == '1') {
        const video = this.el.nativeElement.querySelector('video.video-1');
        video.play();
        const divClose = document.getElementById('videoOne');
        if (divClose) {
          divClose.style.display = 'block';
        }
      }else if (number == '2') {
        const video = this.el.nativeElement.querySelector('video.video-2');
        video.play();
      }else if (number == '3') {
        const video = this.el.nativeElement.querySelector('video.video-3');
        video.play();
        const divClose = document.getElementById('videoTwo');
        if (divClose) {
          divClose.style.display = 'block';
        }
      }else if (number == '4') {
        const video = this.el.nativeElement.querySelector('video.video-4');
        video.play();
        const divClose = document.getElementById('videoFour');
        if (divClose) {
          divClose.style.display = 'block';
        }
      }else if (number == '5') {
        const video = this.el.nativeElement.querySelector('video.video-5');
        video.play();
      }else if (number == '6') {
        const video = this.el.nativeElement.querySelector('video.video-6');
        video.play();
      }
    }, 0);
  }

  closeVideo(number: any) {
    this["video" + number] = false;

    if (number == '1') {
      const video = this.el.nativeElement.querySelector('video.video-1');
      video.pause();
      const divClose = document.getElementById('videoOne');
      if (divClose) {
        divClose.style.display = 'none';
      }
    }else if (number == '2') {
      const video = this.el.nativeElement.querySelector('video.video-2');
      video.pause();
    }else if (number == '3') {
      const video = this.el.nativeElement.querySelector('video.video-3');
      video.pause();
      const divClose = document.getElementById('videoTwo');
      if (divClose) {
        divClose.style.display = 'none';
      }
    }else if (number == '4') {
      const video = this.el.nativeElement.querySelector('video.video-4');
      video.pause();
      const divClose = document.getElementById('videoFour');
      if (divClose) {
        divClose.style.display = 'none';
      }
    }else if (number == '5') {
      const video = this.el.nativeElement.querySelector('video.video-5');
      video.pause();
    }else if (number == '6') {
      const video = this.el.nativeElement.querySelector('video.video-6');
      video.pause();
    }
  }

  pauseAllVideos(event?) {
    document.querySelectorAll('video').forEach((elem: any) => {
      if (elem) {
        try {
          elem.currentTime = 0;
          elem.load();
          elem.pause();
        } catch (error) {
        }
      }
    });
  }

  muteVideo(){
    const video = this.el.nativeElement.querySelector('video.video-sound');
    const video2 = this.el.nativeElement.querySelector('video.video-navigator');
    this.mute = !this.mute;
    if(!this.up){
      if(this.mute){
        video.muted = true;
        video.pause();
      }else{
        video.muted = false;
        video.play();
      }
    }else{
      if(this.mute){
        video2.muted = true;
        video2.pause();
      }else{
        video2.muted = false;
        video2.play();
      }
    }



  }

  videoEnd(number: any) {
    this["video" + number] = false;
    if (number == '1') {
      const video = this.el.nativeElement.querySelector('video.video-1');
      video.pause();
      const divClose = document.getElementById('videoOne');
      if (divClose) {
        divClose.style.display = 'none';
      }
    } else if (number == '2') {
      const video = this.el.nativeElement.querySelector('video.video-2');
      video.pause();
    } else if (number == '3') {
      const video = this.el.nativeElement.querySelector('video.video-3');
      video.pause();
      const divClose = document.getElementById('videoTwo');
      if (divClose) {
        divClose.style.display = 'none';
      }
    } else if (number == '4') {
      const video = this.el.nativeElement.querySelector('video.video-4');
      video.pause();
      const divClose = document.getElementById('videoFour');
      if (divClose) {
        divClose.style.display = 'none';
      }
    } else if (number == '5') {
      const video = this.el.nativeElement.querySelector('video.video-5');
      video.pause();
    } else if (number == '6') {
      const video = this.el.nativeElement.querySelector('video.video-6');
      video.pause();
    } else if (number == '7') {
      this.mute = true;
      const video = this.el.nativeElement.querySelector('video.video-sound');
      video.load();
    } else if (number == '8') {
      this.mute = true;
      const video = this.el.nativeElement.querySelector('video.video-navigator');
      video.load();
    } else if (number == '12') {
      this.mute = true;
      const video = this.el.nativeElement.querySelector('video.main-intro4');
      video.load();
    } else if (number == '14') {
      this.mute = true;
      const video = this.el.nativeElement.querySelector('video.main-intro5');
      video.load();
    }
  }

}
